import React from "react";

const ConsignmentReportTable = ({ data }: { data: any }) => {
  const reportData = data || [];

  const formatDate = (dateStr: string) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    const day = ("0" + date.getDate()).slice(-2);
    const months = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
    ];
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };

  return (
    <div className="overflow-x-auto">
      <table className="table-auto border border-gray-300 w-full min-w-[1000px] text-sm">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-4 py-2 border text-left">Date</th>
            <th className="px-4 py-2 border text-left">Customer</th>
            <th className="px-4 py-2 border text-left">Business Unit</th>
            <th className="px-4 py-2 border text-left">Contract No</th>
            <th className="px-4 py-2 border text-left">Product Code</th>
            <th className="px-4 py-2 border text-left">Product Name</th>
            <th className="px-4 py-2 border text-right">Contract Qty</th>
            <th className="px-4 py-2 border text-right">Sell Qty</th>
            <th className="px-4 py-2 border text-right">Refill Qty</th>
            <th className="px-4 py-2 border text-right">Balance</th>
          </tr>
        </thead>
        <tbody>
          {reportData.length === 0 && (
            <tr>
              <td
                colSpan={10}
                className="px-4 py-4 border text-center text-gray-500"
              >
                No data available
              </td>
            </tr>
          )}
          {reportData.map((row: any, idx: number) => (
            <tr key={idx} className="hover:bg-gray-50">
              <td className="px-4 py-2 border">{formatDate(row.date)}</td>
              <td className="px-4 py-2 border">{row.customer_name}</td>
              <td className="px-4 py-2 border">{row.bu_name}</td>
              <td className="px-4 py-2 border">{row.contract_no}</td>
              <td className="px-4 py-2 border">{row.product_code}</td>
              <td className="px-4 py-2 border">{row.product_name}</td>
              <td className="px-4 py-2 border text-right">
                {row.contract_qty}
              </td>
              <td className="px-4 py-2 border text-right">{row.sell_qty}</td>
              <td className="px-4 py-2 border text-right">{row.refill_qty}</td>
              <td className="px-4 py-2 border text-right">{row.balance}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ConsignmentReportTable;
